import { createContext } from 'react';

export const onClickContext = createContext<((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined>(undefined);
